export const Reset = 'reset'

export const DateNumberFunctions = [
  'eq',
  'neq',
  'gt',
  'lt',
  'gte',
  'lte',
  'between',
  Reset,
]

export const TextFunctions = [
  'eq',
  'neq',
  'contains',
  'not_contains',
  'starts_with',
  'ends_with',
  Reset,
]

export const SelectFunctions = ['eq', 'neq']

export const FilterTypeMap = {
  eq: 'Equals',
  neq: 'Does not equals',
  starts_with: 'Starts with',
  ends_with: 'Ends with',
  gt: 'Greater than',
  lt: 'Less than',
  gte: 'Greater then or equals',
  lte: 'Less then or equals',
  between: 'Between',
  contains: 'Contains',
  not_contains: 'Does not Contain',
  reset: 'Reset',
}
